import React from 'react';
import style from './UpsideBadge.module.css';

const UpsideBadge = ({ change, subtle }) => {
  return (
    <span className={`${style.wrapper} ${change < 0 && style.wrapperDown} ${subtle && style.subtle}`}>
      <img src={change < 0 ? '/react/phosphor/arrow-down-bold.svg' : '/react/phosphor/arrow-up-bold.svg'} className={style.icon} />
      <span className={style.label}>{Math.abs(change)}% {change < 0 ? 'downside' : 'upside'}</span>
    </span>
  );
};

export default UpsideBadge;
